/**
 * Session Debug Utility
 * Use this to verify session state at any point in the app
 */
export const debugSession = () => {
  console.group('🔍 Session Debug Report');
  
  // Check localStorage
  console.group('📦 localStorage');
  console.log('banking_crm_token:', localStorage.getItem('banking_crm_token'));
  console.log('banking_crm_user:', localStorage.getItem('banking_crm_user'));
  console.groupEnd();
  
  // Check sessionStorage
  console.group('💾 sessionStorage');
  console.log('banking_crm_token:', sessionStorage.getItem('banking_crm_token'));
  console.log('banking_crm_user:', sessionStorage.getItem('banking_crm_user'));
  console.groupEnd();
  
  // Check if token exists
  const token = localStorage.getItem('banking_crm_token') || sessionStorage.getItem('banking_crm_token');
  console.log('🔑 Token exists:', !!token);
  if (token) {
    console.log('   Length:', token.length);
    console.log('   First 50 chars:', token.substring(0, 50) + '...');
  }
  
  // Check if user exists
  const userStr = localStorage.getItem('banking_crm_user') || sessionStorage.getItem('banking_crm_user');
  console.log('👤 User exists:', !!userStr);
  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      console.log('   User data:', user);
    } catch (e) {
      console.log('   Error parsing user:', e.message);
    }
  }
  
  console.groupEnd();
};

/**
 * Clear all session data
 */
export const clearAllSessions = () => {
  console.log('🧹 Clearing all session data...');
  localStorage.removeItem('banking_crm_token');
  localStorage.removeItem('banking_crm_user');
  sessionStorage.removeItem('banking_crm_token');
  sessionStorage.removeItem('banking_crm_user');
  console.log('✅ Session data cleared');
};

/**
 * Manually set token for testing
 */
export const setTestToken = (token) => {
  console.log('🧪 Setting test token');
  localStorage.setItem('banking_crm_token', token);
  sessionStorage.setItem('banking_crm_token', token);
  console.log('✅ Test token set, length:', token.length);
};

// Make utilities available globally for debugging
if (typeof window !== 'undefined') {
  window.debugSession = debugSession;
  window.clearAllSessions = clearAllSessions;
  window.setTestToken = setTestToken;
  console.log('🛠️ Debug utilities available: debugSession(), clearAllSessions(), setTestToken(token)');
}
